// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import GenericLegend, { LegendItem } from '../../charts/GenericLegend';
import { InfoTooltip } from '../../tooltips';

// Utils
import { GIF_GRAPH_CONFIGS, BMOi18n } from '../../../../utils/bmo-gif/constants';
import { getMaturityGuaranteeDisclaimer, getDeathBenefitDisclaimer } from '../../../../utils/bmo-gif/index';

type Props = {
  locale: string;
  dark?: boolean;
  tooltipDisclaimer?: boolean;
  planOption?: string;
  withdrawal?: boolean;
  deposit?: boolean;
};

const BMOGifLegend = ({ locale, dark, tooltipDisclaimer, planOption, withdrawal, deposit }: Props) => {
  const maturityLabel = tooltipDisclaimer ? BMOi18n[locale].SCENARIOS.MATURITY_GUARANTEE : `${BMOi18n[locale].SCENARIOS.MATURITY_GUARANTEE}**`;
  const dbLabel = tooltipDisclaimer ? BMOi18n[locale].SCENARIOS.DEATH_BENEFIT_GUARANTEE : `${BMOi18n[locale].SCENARIOS.DEATH_BENEFIT_GUARANTEE}***`;
  const depositLabel = tooltipDisclaimer ? BMOi18n[locale].SCENARIOS.SUBSEQUENT_DEPOSIT : `${BMOi18n[locale].SCENARIOS.SUBSEQUENT_DEPOSIT}*`;

  const items: LegendItem[] = [
    {
      label: BMOi18n[locale].SCENARIOS.PORTFOLIO_VALUE,
      color: GIF_GRAPH_CONFIGS.PORTFOLIO_VALUE.color,
    },
    {
      label: BMOi18n[locale].SCENARIOS.NET_WITHDRAWAL,
      color: GIF_GRAPH_CONFIGS.NET_WITHDRAWAL.color,
      hidden: withdrawal,
    },
    {
      label: depositLabel,
      color: GIF_GRAPH_CONFIGS.SUBSEQUENT_DEPOSIT.color,
      hidden: deposit,
      getTooltip: () => tooltipDisclaimer && <InfoTooltip message={BMOi18n[locale].GIF_GRAPH.DEPOSIT} />,
    },
    {
      label: maturityLabel,
      color: GIF_GRAPH_CONFIGS.MATURITY_GUARANTEE.color,
      getTooltip: () => tooltipDisclaimer && <InfoTooltip message={getMaturityGuaranteeDisclaimer(locale, planOption)} />,
    },
    {
      label: dbLabel,
      color: GIF_GRAPH_CONFIGS.DEATH_BENEFIT_GUARANTEE.color,
      getTooltip: () => tooltipDisclaimer && <InfoTooltip message={getDeathBenefitDisclaimer(locale, planOption)} />,
    },
  ].filter(item => !item.hidden);
  return <GenericLegend disableLabelTooltip className={classNames('bmo-gif-legend-v2', { dark })} items={items} />;
};

export default BMOGifLegend;
